module.exports = __webpack_public_path__ + "img/GI.d9190007.svg";